import { IconsLinear, IconsNocowanie } from '@nocowanie/icons';

import { AmenityApiMapping } from '@app/enums';
/**
 * Search filter constants with their display names
 */

/**
 * Property type filter options
 */
export const PROPERTY_TYPE_LABELS = [
    { value: 63, label: 'Apartamenty' },
    { value: 82, label: 'Domki' },
    { value: 2, label: 'Hotele' },
    { value: 3, label: 'Kwatery i pokoje' },
    { value: 4, label: 'Pensjonaty' },
    { value: 127, label: 'Wille' },
    { value: 1, label: 'Agroturystyka' },
    { value: 243, label: 'Domy wakacyjne' },
    { value: 277, label: 'Home Office' },
    { value: 71, label: 'Hostele' },
    { value: 5, label: 'Internaty, schroniska' },
    { value: 84, label: 'Motele' },
    { value: 186, label: 'Noclegi pracownicze' },
    { value: 61, label: 'Ośrodki Szkoleniowe i Wypoczynkowe' },
    { value: 125, label: 'Zajazdy' },
];

/**
 * Property type expansion rules configuration
 * These rules define cases where selecting one property type should automatically
 * include additional property types in the search without showing them as selected filters.
 */
export const PROPERTY_TYPE_EXPANSION_RULES = [
    {
        triggerId: 3,
        additionalIds: [84],
    },
];

/**
 * Amenities filter options
 */
export const AMENITIES_LABELS = [
    { value: AmenityApiMapping.Internet, label: 'Internet', icon: <IconsNocowanie.Wifi /> },
    { value: AmenityApiMapping.Parking, label: 'Parking', icon: <IconsNocowanie.ParkingCircle /> },
    { value: AmenityApiMapping.Catering, label: 'Wyżywienie', icon: <IconsNocowanie.Meals /> },
    { value: AmenityApiMapping.Tv, label: 'Telewizor', icon: <IconsNocowanie.Tv /> },
    {
        value: AmenityApiMapping.SwimmingPool,
        label: 'Basen',
        icon: <IconsNocowanie.SwimmingPool />,
    },
    { value: AmenityApiMapping.Jacuzzi, label: 'Jacuzzi', icon: <IconsNocowanie.Jacuzzi /> },
    { value: AmenityApiMapping.Sauna, label: 'Sauna', icon: <IconsNocowanie.Sauna /> },
    {
        value: AmenityApiMapping.Playground,
        label: 'Plac zabaw',
        icon: <IconsNocowanie.Playground />,
    },
    { value: AmenityApiMapping.Bicycle, label: 'Rowery', icon: <IconsNocowanie.Bike /> },
    {
        value: AmenityApiMapping.CardPayment,
        label: 'Płatność kartą',
        icon: <IconsLinear.EmptyWallet />,
    },
    {
        value: AmenityApiMapping.Pets,
        label: 'Akceptujemy zwierzęta',
        icon: <IconsNocowanie.Pets />,
    },
];

/**
 * Rating filter options
 */
export const RATING_LABELS = [
    { value: 4.51, label: 'Rewelacyjny', iconColor: 'green.300' },
    { value: 4, label: 'Bardzo dobry', iconColor: 'green.400' },
    { value: 3, label: 'Dobry', iconColor: 'orange.600' },
    { value: 2, label: 'Przyzwoity', iconColor: 'orange.600' },
    { value: 1, label: 'Przeciętny', iconColor: 'red.600' },
];

/**
 * Provision type filter options
 */
export const PROVISION_LABELS = [
    { value: 5, label: 'Bez wyżywienia' },
    { value: 1, label: 'Śniadania' },
    { value: 2, label: 'Śniadania i obiadokolacje' },
    { value: 4, label: 'Pełne wyżywienie' },
];

/**
 * Reservation features filter options
 */
export const RESERVATION_FEATURES_LABELS: Record<string, string> = {
    realtimeBookingModel: 'Natychmiastowa rezerwacja',
    freeCancellation: 'Bezpłatne anulowanie',
    withoutPrepayment: 'Brak przedpłaty',
};

/**
 * Filter category labels
 */
export const FILTER_CATEGORY_LABELS = {
    PROPERTY_TYPE: 'Rodzaj obiektu',
    AMENITIES: 'Udogodnienia',
    RATING: 'Średnia ocena',
    PROVISION: 'Wyżywienie',
    PRICE_FROM: 'Cena od',
    PRICE_TO: 'Cena do',
    PRICE_RANGE: 'Cena za cały pobyt',
    RESERVATION_FEATURES: 'Cechy rezerwacji',
};

/**
 * Filter key names used in the search filters
 */
export const FILTER_KEYS = {
    PROPERTY_TYPE: 'propertyType',
    AMENITIES: 'amenities',
    RATING: 'rating',
    PRICE_FROM: 'priceFrom',
    PRICE_TO: 'priceTo',
    PROVISION: 'provision',
    RESERVATION_FEATURES: 'reservationFeatures',
} as const;
